"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const helpers_1 = require("./helpers");
const helpers_2 = require("../../utils/helpers");
const Table_1 = __importDefault(require("../Table/Table"));
const TableRow_1 = __importDefault(require("../TableRow/TableRow"));
const TableCell_1 = __importDefault(require("../TableCell/TableCell"));
const Inputs_1 = require("../../Inputs");
const Layout_1 = require("../../Layout");
const Svgs_1 = require("../../Svgs");
require("./index.css");
const Checkbox_1 = __importDefault(require("../../Buttons/Checkbox/Checkbox"));
class SearchableTable extends React.Component {
    constructor(props) {
        super(props);
        this._handleColumnSort = (columnKey) => {
            const { sortProps } = this.props;
            if (sortProps) {
                const { onSort } = sortProps;
                onSort(columnKey);
            }
            else {
                const { sorting } = this.state;
                const activeDirection = columnKey === sorting.sortBy ? sorting.direction : 0;
                let newDirection;
                if (activeDirection === 1) {
                    newDirection = -1;
                }
                else if (activeDirection === -1) {
                    newDirection = 0;
                }
                else {
                    newDirection = 1;
                }
                this.setState({
                    sorting: { sortBy: columnKey, direction: newDirection },
                });
            }
        };
        this._handleRowSelection = (id) => {
            const { onRowSelection } = this.props;
            if (onRowSelection) {
                onRowSelection(id);
            }
        };
        this._handleCheckboxClick = (e, id) => {
            e.stopPropagation();
            const { checkboxProps } = this.props;
            if (checkboxProps) {
                checkboxProps.onClick(id);
            }
        };
        this.handleSearch = (query) => {
            const { searchProps } = this.props;
            if (searchProps) {
                const { onChange } = searchProps;
                onChange(query);
            }
            else {
                this.setState({
                    query,
                });
            }
        };
        this._parseCellValue = (value) => {
            if (value === null || value === undefined || value === "") {
                return "N/A";
            }
            if (typeof value === "object") {
                return (React.createElement(React.Fragment, null,
                    value.icon,
                    value.value));
            }
            return value;
        };
        this._renderTableLabels = () => {
            const { labelKeyMap, labelClasses, sortProps, checkboxProps } = this.props;
            const { sorting } = this.state;
            let { sortBy, direction } = sorting;
            if (sortProps) {
                const { sorting: sortingOverride } = sortProps;
                sortBy = sortingOverride.sortBy;
                direction = sortingOverride.direction;
            }
            const labels = new Array();
            if (checkboxProps) {
                labels.push(React.createElement("div", { key: "checkbox_label", className: `${(0, helpers_2.getAdditionalCSSClasses)(labelClasses)} searchable__table_table_cell_header` },
                    React.createElement("div", { className: "searchable__table_table_header_container" })));
            }
            Object.keys(labelKeyMap).forEach(label => {
                let chevron = React.createElement(Svgs_1.SortChevron, { color: "transparent" });
                if (sortBy === labelKeyMap[label]) {
                    if (direction === 1 || direction === -1) {
                        chevron = (React.createElement(Svgs_1.SortChevron, { transform: direction === 1 ? "rotate(180)" : "" }));
                    }
                }
                labels.push(React.createElement("div", { key: label, onClick: () => this._handleColumnSort(labelKeyMap[label]), className: `${(0, helpers_2.getAdditionalCSSClasses)(labelClasses)} searchable__table_table_cell_header` },
                    React.createElement("div", { className: "searchable__table_table_header_container" },
                        label.toUpperCase(),
                        chevron)));
            });
            return labels;
        };
        this._renderTableRows = () => {
            const { data, labelKeyMap, selectedRowIds, disabledRowIds, rowClasses, checkboxProps, sortProps, searchProps, } = this.props;
            const { query, sorting } = this.state;
            let filteredData = data;
            if (!searchProps) {
                filteredData = (0, helpers_1.getFilteredData)(query, data, labelKeyMap);
            }
            if (sorting.sortBy && !sortProps) {
                filteredData = (0, helpers_1.getSortedData)(sorting.sortBy, filteredData, sorting.direction);
            }
            if (filteredData.length < 1) {
                return (React.createElement(TableRow_1.default, { className: `${(0, helpers_2.getAdditionalCSSClasses)(rowClasses)} searchable__table_table_row_darkened` },
                    checkboxProps && (React.createElement(TableCell_1.default, { className: "searchable__table_table_cell" })),
                    Object.keys(labelKeyMap).map((key, i) => {
                        if (i === 0) {
                            return (React.createElement(TableCell_1.default, { key: "no_results_cell", className: "searchable__table_table_cell" }, "No results found"));
                        }
                        return (React.createElement(TableCell_1.default, { key: `${key}_cell_no_results`, className: "searchable__table_table_cell" }));
                    })));
            }
            return filteredData.map((row, index) => {
                let classNames = [];
                if (index % 2 === 0) {
                    classNames.push("searchable__table_table_row_darkened");
                }
                else {
                    classNames.push("searchable__table_table_row");
                }
                if (selectedRowIds && selectedRowIds.includes(row.id)) {
                    classNames.push("searchable__table_table_row_selected");
                }
                return (React.createElement(TableRow_1.default, { key: row.id, className: `${(0, helpers_2.getAdditionalCSSClasses)(rowClasses)} ${classNames.join(" ")}`, onClick: () => this._handleRowSelection(row.id), disabled: disabledRowIds && disabledRowIds.includes(row.id) }, this._renderTableCells(row)));
            });
        };
        this._renderTableCells = (row) => {
            const { labelKeyMap, cellClasses, checkboxProps } = this.props;
            const additionalClasses = cellClasses ? cellClasses : "";
            return (React.createElement(React.Fragment, null,
                checkboxProps && (React.createElement(TableCell_1.default, { key: `${row.id}_checkbox`, className: `${(0, helpers_2.getAdditionalCSSClasses)(additionalClasses)} searchable__table_table_cell` },
                    React.createElement(Checkbox_1.default, { checked: checkboxProps.checkedIds.findIndex(id => id === row.id) > -1, onClick: e => this._handleCheckboxClick(e, row.id) }))),
                Object.values(labelKeyMap).map((key) => {
                    return (React.createElement(TableCell_1.default, { key: `${row.id}_${key}`, className: `${(0, helpers_2.getAdditionalCSSClasses)(additionalClasses)} searchable__table_table_cell` }, this._parseCellValue(row[key])));
                })));
        };
        let sorting = {
            sortBy: null,
            direction: 0,
        };
        const { defaultSort } = props;
        if (defaultSort) {
            sorting = defaultSort;
        }
        this.state = {
            query: "",
            sorting,
        };
    }
    componentWillUnmount() {
        this.setState({
            query: "",
        });
    }
    render() {
        const { searchDetail, tableClasses, containerClasses, searchProps } = this.props;
        const { query } = this.state;
        let searchValue = query;
        if (searchProps) {
            const { value } = searchProps;
            searchValue = value;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: `${(0, helpers_2.getAdditionalCSSClasses)(containerClasses)} searchable__table_container` },
                React.createElement(Inputs_1.Input, { iconLeft: React.createElement(Svgs_1.MagnifyingGlass, null), placeholder: "Search", value: searchValue, onChange: this.handleSearch, inputClasses: "searchable__table_table_search" }),
                searchDetail),
            React.createElement(Table_1.default, { headers: this._renderTableLabels(), className: `${(0, helpers_2.getAdditionalCSSClasses)(tableClasses)} searchable__table_table` }, this._renderTableRows()),
            React.createElement(Layout_1.Divider, { classes: "searchable__table-divider" })));
    }
}
exports.default = SearchableTable;
//# sourceMappingURL=SearchableTable.js.map